// Viewport height utility
export class ViewportUtils {
  constructor() {
    this.init();
  }

  private init(): void {
    window.addEventListener('resize', this.setVh.bind(this));
    window.addEventListener('load', this.setVh.bind(this));
  }

  private setVh(): void {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
}
